<script setup lang="ts">
import { breakpointsTailwind } from '@vueuse/core'
import type { Component } from 'vue'
import Drawer from './components/Drawer/index.vue'
import DrawerElementalLists from './pages/DrawerElementalLists/index.vue'

import type { SideBarMode } from '~~/src/stores/sidebar'
import { useSidebarStore } from '~~/src/stores/sidebar'
import { HEADER_HEIGHT } from '~~/src/composables/layout'

defineOptions({
  name: 'DrawerSidebarRight',
})

const { state } = useSidebarStore()
const { isSmaller } = useBreakpoints(breakpointsTailwind)
const isMobile = ref(isSmaller('md'))
useResizeObserver(window.document.body, () => {
  isMobile.value = isSmaller('md')
})

const views: Record<SideBarMode, Component> = {
  view: DrawerElementalLists,
  edit: defineAsyncComponent(() => import('./pages/EditElemental/index.vue')),
  folder: defineAsyncComponent(() => import('./pages/FolderView/index.vue')),
  export: defineAsyncComponent(() => import('./pages/Export/index.vue')),
}
</script>

<template>
  <div v-if="!isMobile" relative>
    <Drawer id="drawer-sidebar-right isolate">
      <ClientOnly>
        <Transition name="fade">
          <Suspense>
            <component :is="views[state.mode]" />
          </Suspense>
        </Transition>
      </ClientOnly>
    </Drawer>
  </div>
  <Teleport to="body">
    <div
      v-if="isMobile" class="absolute right-0 top-0 -z-999 max-w-full"
      :class="{
        'z-999!': state.isOpen,
        'invisible': !state.isOpen,
      }"
      :style="{
        paddingTop: `${HEADER_HEIGHT}px`,
        height: 'calc(100% - 57px)',
      }"
    >
      <Drawer id="drawer-sidebar-right isolate">
        <ClientOnly>
          <Transition name="fade">
            <Suspense>
              <component :is="views[state.mode]" />
            </Suspense>
          </Transition>
        </ClientOnly>
      </Drawer>
    </div>
  </Teleport>
</template>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
